import React from 'react';
import PropTypes from 'prop-types';
import { white } from 'ansi-colors';

export const FacebookIcon = ({ width }) => {
  return (
    <svg width={width} viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9214 13.3981L12.5825 9.08738H8.4466V6.29126C8.4466 5.11165 9.0233 3.96117 10.8757 3.96117H12.7573V0.291262C12.7573 0.291262 11.0505 0 9.41942 0C6.01165 0 3.78641 2.06505 3.78641 5.80194V9.08738H0V13.3981H3.78641V23.8194C4.5466 23.9388 5.32427 24 6.11651 24C6.90874 24 7.68641 23.9388 8.4466 23.8194V13.3981H11.9214Z"
        fill="white"
      />
    </svg>
  );
};

FacebookIcon.propTypes = {
  width: PropTypes.string, //24
};
FacebookIcon.defaultProps = {
  width: '30px',
};
